<template>
  <input-base
    :input="input"
    :review-mode="reviewMode"
    :error="error"
    class="form-input-textarea"
    :class="{
      'has-error': input.validation.limit && wordCount > input.validation.limit,
    }"
  >
    <div v-if="!input.attributes.locked && !reviewMode" class="flex-1 relative">
      <textarea
        :id="input.key"
        ref="textarea"
        class="w-full leading-normal"
        :name="input.key"
        autocomplete="off"
        :rows="rows"
        :placeholder="input.attributes.placeholder"
        :readonly="input.attributes.locked || reviewMode"
        :required="input.attributes.required"
        :value="applicationValue"
        :class="{
          'mb-10': !input.validation.limit,
        }"
        @input="updateInput(parentField, input.key, $event.target.value)"
        v-on="$listeners"
      />
      <p
        v-if="input.validation.limit"
        class="p-2 -mt-px text-xs w-full flex justify-between"
        :class="{
          'bg-grey-200 text-grey-600': wordCount <= input.validation.limit,
          'bg-negative-400 text-negative-100':
            wordCount > input.validation.limit || error || false,
        }"
      >
        <strong v-if="wordCount > input.validation.limit">
          Word count exceeded!
        </strong>
        <span class="ml-auto">
          Word Count: {{ wordCount }}/{{ input.validation.limit }}
        </span>
      </p>
    </div>
    <div
      v-else
      class="flex-1 relative leading-loose pt-2"
      :style="{
        minHeight: rows + 'em',
      }"
      v-html="autop(applicationValue)"
    />
  </input-base>
</template>

<script>
import { inputHelperMixin } from "../../mixins/inputHelper";
import autosize from "autosize";
export default {
  name: "InputMultiline",
  mixins: [inputHelperMixin],
  computed: {
    rows() {
      const defaultRows = 5;
      const maxRows = 10;
      if (!Number.isInteger(this.input.validation.limit)) return defaultRows;
      const rows = Math.round(this.input.validation.limit / 17);
      return rows <= defaultRows
        ? defaultRows
        : rows >= maxRows
        ? maxRows
        : rows;
    },
    wordCount() {
      if (["", "", null, undefined].indexOf(this.applicationValue) !== -1)
        return 0;
      return this.applicationValue.match(/\S+/g)?.length ?? 0;
    },
  },
  mounted() {
    autosize(this.$refs.textarea);
  },
};
</script>

<style>
.form-input-textarea .form-label {
  @apply mb-2;
}
.form-input-textarea textarea {
  @apply block border p-4;
}

.form-input-textarea .has-error textarea,
.form-input-textarea.has-error textarea {
  @apply border-negative-200;
}

.form-input-textarea .has-error textarea:focus,
.form-input-textarea.has-error textarea:focus {
  @apply border-negative-400;
}
</style>
